import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { IHistoryContext, withHistoryContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { filterByDocumentType } from 'Utility/documentHandling';

const GAFHistory = ({
  documents = [],
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<'gaf'>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="interviewSurveys.gaf.title" />}
    newButton={
      <DocumentCreationButton
        name="cmap"
        text={'interviewSurveys.gaf.newGaf'}
        onClick={startEdit && startEdit({}, 'gaf')}
        width={15}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={filterByDocumentType(documents, 'gaf')}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="interviewSurveys.gaf.gafValue" />
          </Item>
        </>
      }
      contentFormat={(d: IDocumentWithTypeV2<'gaf'>): React.JSX.Element => (
        <>
          <Item xs={2}>{formatPartialDate(d.date)}</Item>
          <Item xs={2}>{d.gafClass === '0' ? '0' : d.gafValue || d.gafValue === 0 ? d.gafValue : '-'}</Item>
          <Item xs={5}>{d.gafClass && <FormattedMessage id={`interviewSurveys.opts.gaf.${d.gafClass}`} />}</Item>
          <Item xs={3}>{startEdit && <HistoryRowControls document={d} startEdit={startEdit} view={view} />}</Item>
        </>
      )}
    />
  </HistorySection>
);

export default withHistoryContext(GAFHistory);
